module.exports = {
	title: 'Header Toggle',
	notes: '',
	context: {
		open: 'Meny',
		close: 'Stäng'
	}
};